import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Optional, computed } from '@angular/core';
import { App } from '@df/core/app';
import { Client } from '@df/core/service/client';
import { ZippyModule } from '@df/legacy/ui/zippy/zippy.module';
import { AdvancedCommerceListingFiltersComponentDef } from '@df/module-advanced-commerce';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { ModalModule } from '@df/ui/modal/modal.module';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { NListing } from 'projects/app-default/src/app/catalog/ui/listing/product-listing.interface';
import { ExpandableComponent } from 'projects/app-default/src/app/ui/display/expandable/expandable.component';
import { Subscription } from 'rxjs';
import { ModalLayoutRightComponent, NModalLayoutRight } from '../../../../ui/modal/modal-layout-right.component';
import { AdvancedCommerceProductListingSortComponent } from '../sort/advanced-commerce-advanced-commerce-product-listing-sort.component';
import { AdvancedCommerceFilterAttributeOptionComponent } from './advanced-commerce-filter-attribute-option.component';
import { AdvancedCommerceFilterAttributeRangeComponent } from './advanced-commerce-filter-attribute-range.component';
export namespace NAdvancedCommerceListingFiltersModal {
    /**
     * Modal identifier
     */
    export const id = 'ac-product-listing-filters';

    /**
     * Data passed to modal
     */
    export interface Data {}
}
@DfModal({
    id: NAdvancedCommerceListingFiltersModal.id,
    name: 'Advanced Commerce Listing Filters Popup',
    position: 'right',
    config: sizeName => ({
        ...NModalLayoutRight.ModalConfig,
        width: { S: '100vw', M: '100vw', L: '37.5rem', X: '37.5rem' }[sizeName],
        minWidth: { S: '100vw', M: '100vw' }[sizeName],
        height: '100%'
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: sizeName => ({ S: ['S'], M: ['M'], L: ['L', 'X'], X: ['L', 'X'] })[sizeName]
})
@Component({
    selector: 'ac-filter-modal',
    templateUrl: '../../../../catalog/ui/listing/filter/filter-modal.html',
    standalone: true,
    imports: [ModalLayoutRightComponent, TranslationModule, ExpandableComponent, ZippyModule, NgComponentOutlet, ModalModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvancedCommerceListingFiltersModalComponent
    extends AdvancedCommerceListingFiltersComponentDef
    implements NDfModal.IModalComponent, NListing.IFilter
{
    /**
     * Modal option config
     */
    modalConfig!: NDfModal.IConfig;

    /**
     * Listing changes subscription
     */
    private listingSubscription?: Subscription;

    constructor(
        readonly client: Client,
        private app: App,
        @Optional()
        protected modalRef: ModalRef<AdvancedCommerceListingFiltersModalComponent>,
        @Optional()
        @Inject(MODAL_DATA)
        public data: NAdvancedCommerceListingFiltersModal.Data
    ) {
        super();
    }

    getFilterOptions = computed(() => {
        return [...this.store.filtersWithOptions()];
    });

    get activeFiltersCount(): number | undefined {
        //       return this.listing?.filterSelection?.length;
        return;
    }
    /**
     * Close modal
     */
    close() {
        this.modalRef.close();
    }
    clearFilters(): void {
        this.store.filtersResetSelection();
    }

    private detectChanges() {
        this.changeDetectorRef.detectChanges();
    }

    get sortSelectedLabel(): string | undefined {
        return this.store
            .sortingEntities()
            ?.find(
                o =>
                    o.code ===
                    (Array.isArray(this.store.queryParamSort())
                        ? this.store.queryParamSort()?.[0]
                        : this.store.queryParamSort() || 'default')
            )?.label;
    }

    get sortOutlet(): NListing.IOutlet {
        return { component: AdvancedCommerceProductListingSortComponent, inputs: { displayAs: 'buttons' } };
    }

    getFilterOutlet(filter): NListing.IOutlet {
        return filter.id === 'price'
            ? { component: AdvancedCommerceFilterAttributeRangeComponent, inputs: { filter: filter } }
            : {
                  component: AdvancedCommerceFilterAttributeOptionComponent,
                  inputs: { filter: filter }
              };
    }
}
